export var AssetSkippedReason;

(function (AssetSkippedReason) {
  AssetSkippedReason["InsufficientLighting"] = "insufficient_lighting";
  AssetSkippedReason["LowResolution"] = "low_resolution";
  AssetSkippedReason["NotRealFood"] = "not_real_food";
  AssetSkippedReason["DuplicatePhoto"] = "duplicate_photo";
  AssetSkippedReason["InappropriateContent"] = "inappropriate_content";
  AssetSkippedReason["BlockedFood"] = "blocked_food";
  AssetSkippedReason["Other"] = "other";
})(AssetSkippedReason || (AssetSkippedReason = {}));

export var InstantJobError;

(function (InstantJobError) {
  InstantJobError["instant_job_incomplete"] = "instant_job_incomplete";
  InstantJobError["instant_jobs_taken"] = "instant_jobs_taken";
})(InstantJobError || (InstantJobError = {}));